import { render, staticRenderFns } from "./DictaminationHit.vue?vue&type=template&id=4cb82ba4"
import script from "./DictaminationHit.vue?vue&type=script&lang=js"
export * from "./DictaminationHit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports